import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;

  width: 100%;
  display: flex;
  flex-direction: column;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  padding: 24px;
  box-sizing: border-box;

  gap: 8px;

  .input-sequence-name {
    max-width: 720px;
    flex: 1;
  }
`

export const ButtonImportSequence = styled.button`
  height: 28px;

  display: flex;
  align-items: center;
  gap: 6px;

  background-color: white;
  outline: none;
  border: none;
  cursor: pointer;

  border-radius: 6px;
  border: 1px solid var(--border-neutral, #bbc1d3);

  padding: 4px 8px;
  box-sizing: border-box;

  color: var(--foreground-neutral-faded, #4d5874);

  /* Body 3/Medium */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const ImportSequenceImg = styled.img``

export const SequenceTemplatePlanningContainer = styled.div`
  height: calc(100vh - 53px - 112px);
`
